import { render } from "./CreateLabel.vue?vue&type=template&id=5591c5a4"
import script from "./CreateLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateLabel.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Label/CreateLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5591c5a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5591c5a4', __exports__)) {
    api.reload('5591c5a4', __exports__)
  }
  
  module.hot.accept("./CreateLabel.vue?vue&type=template&id=5591c5a4", () => {
    api.rerender('5591c5a4', render)
  })

}


export default __exports__